import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './core/router';
import { ThemeProvider } from './core/contexts/ThemeContext';
import { FontSettingsProvider } from './front/contexts/FontSettingsContext';
import { LearningRecordsCacheProvider } from './front/contexts/LearningRecordsCacheContext';

function App() {
  return (
    <ThemeProvider>
      <FontSettingsProvider>
        <BrowserRouter>
          <LearningRecordsCacheProvider>
            <AppRouter />
          </LearningRecordsCacheProvider>
        </BrowserRouter>
      </FontSettingsProvider>
    </ThemeProvider>
  );
}

export default App;